import React from 'react';
import { FUNDING_COMMISSION_STATUS_STYLES } from '../../utils/funding/constants';

const FundingCommissionStatusBadge = ({ status }) => {
  if (!status) return null;
  const style = FUNDING_COMMISSION_STATUS_STYLES[status] || 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200';
  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${style}`}>
      {status}
    </span>
  );
};

export default FundingCommissionStatusBadge;
